import React, { useState , useEffect, useRef} from 'react';
//import { glossaryItems } from '../../utils/translations/en-glossaryItems.js';
import LetterButton from './LetterButton.jsx';
import GlossaryItem from './GlossaryItem.jsx';
import Button from './GlossaryComponents/button/Button.jsx';
import Dropdown from './GlossaryComponents/dropdown/Dropdown.jsx';
import { AlignLeft, Paperclip, Printer } from 'lucide-react';
import './glossary.css'
import { useTranslation } from '../../utils/hooks/translateHook.js';
import { useGlossaryItems } from '../../utils/hooks/translateGlossaryItems.js';
import { randomGlossaryImage } from '../../utils/randomGlossaryImages.js';


const GlossarySection = () => {
  const glossaryItems = useGlossaryItems();

  
  const glossaryTitles = glossaryItems
    .filter(item => item && typeof item.title === "string")
    .map(item => item.title);

  const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
  const [search, setSearch] = useState('');
  const [filterLetter, setFilterLetter] = useState('');
  const [selectedWord, setSelectedWord] = useState('');
  const [modalType, setModalType] = useState(null);
  const [isAsideOpen, setIsAsideOpen] = useState(true);

  const t = useTranslation();

  const mainRef = useRef(null);

  const filteredItems = glossaryTitles.filter(
    item =>
      item.toLowerCase().startsWith(filterLetter.toLowerCase()) &&
      item.toLowerCase().includes(search.toLowerCase())
  );


  const cleanFilters = () => {
    setSearch('');
    setFilterLetter('');
  };

  const handleSelectWord = word => {
    setSelectedWord(word);
    setIsAsideOpen(false);
    setTimeout(() => {
      document.getElementById('glossary-head')
      ?.scrollIntoView({ behavior: 'smooth', block: 'start'});

    }, 100);
  };

  const toggleAside = () => {
    setIsAsideOpen(prev => !prev);
  };

/*   const handlePrint = () => {
    window.print();
  }; */

  const selectedItem = glossaryItems.find(item => item.title === selectedWord);

  const handlePrint = () => {
    const title = selectedItem?.title;
    const contentEl = document.getElementById('glossary-content');
    if (title && contentEl) {
      const heading = document.createElement('h1');
      heading.innerText = title;
      heading.style.marginTop = '0';
      contentEl.prepend(heading);
    }
    window.print();
  };
  

  const modalRef = useRef();
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        setModalType(null);
      } 
    }  
    const handleClickOutside = (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        setModalType(null);
      }
    };
    if (modalType) {
      document.addEventListener('keydown', handleKeyDown);
      document.addEventListener('mousedown', handleClickOutside);
    }
  
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [modalType]);

  console.log("Selected image object:", selectedItem?.img);

  return (
    <div id="pageTop">
    <section id="glossary" className="glossary-section container">
    
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />

      <aside className={`glossary-aside ${isAsideOpen ? 'open' : 'closed'}`}>
        <input
          id="search"
          type="text"
          placeholder={t('search')}
          className="glossary-input"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
        <div className="glossary-letters">
          {letters.map(letter => (
            <LetterButton
              key={letter}
              letter={letter}
              filterLetter={filterLetter}
              setFilterLetter={setFilterLetter}
            />
          ))}
        </div>
        <ul className="glossary-list">
          {filteredItems.length > 0 ? (
            filteredItems.map(item => (
              <GlossaryItem
                key={item}
                item={item}
                selectedWord={selectedWord}
                setSelectedWord={handleSelectWord}
              />
            ))
          ) : (
            <li className="glossary-empty">{t('glossaryEmpty')}</li>
          )}
        </ul>
        <div id="glossary-buttons">
          <Button onClick={cleanFilters} type="danger" label={t('cleanFilters')} />
          <Button className='close-options' onClick={toggleAside} label={isAsideOpen ? t('closeOptions') : t('openOptions')} />
        </div>
      </aside>
      <main  ref={mainRef} className="glossary-main" id="glossary-head">
        <div className="glossary-header">
          <div className="glossary-info">
            <h1 className="glossary-title">{t('glossaryContent')}</h1>
            <p className="glossary-selected">{selectedWord || 'No term selected'}</p>
            {selectedItem && (
              <>
                <div className="glossary-actions">
                  <Button icon={<Printer />} label={t('print')} onClick={() => setModalType('print')} />
                  <Button icon={<Paperclip />} label={t('links')} onClick={() => setModalType('links')} />
                </div>
                <Dropdown title={selectedWord} className="glossary-dropdown" style={AlignLeft}>
                  {selectedItem.predescription}
                </Dropdown>
                <p style={{fontSize: "12px", textAlign: "center"}}>This artwork is taken from <a href="https://www.metmuseum.org/art/collection" style={{fontSize: "12px"}}>Met Colleciton</a> </p>
              </>
            )}
          </div>
          {selectedItem && (
          
            <a href={selectedItem.img.link} target="_blank" style={{ textDecoration: "none", width: "100%" }}>
            <div className="glossary-image"  id="glossary-top"
              style={{ backgroundImage: `url(${selectedItem.img.src})` }}
              title={selectedItem.img.alt}
            />
            </a>
          
          )}
        </div>

        <div className="glossary-content">
          {selectedItem ? (
            <div id="glossary-content" dangerouslySetInnerHTML={{ __html: selectedItem.description }} />
          ) : (
            'Select a term to see the description.'
          )}
        </div>
      </main>
      {modalType && (
        <div className="glossary-modal">
          <div className="glossary-modal-content" ref={modalRef}>
            <h2 className="glossary-modal-title">
              {modalType === 'print' ? 'Print Options' : 'Related Links'}
            </h2>
            {modalType === 'links' ? (
              <ul className="glossary-links">
                {selectedItem && selectedItem.links && selectedItem.links.length > 0 ? (
                  selectedItem.links.map((link, index) => (
                    <li key={index}>
                      <a href={link.link} className="glossary-link" target="_blank" rel="noopener noreferrer">
                        {link.label}
                      </a>
                    </li>
                  ))
                ) : (
                  <li className="glossary-no-links">No links available for this item.</li>
                )}
              </ul>
            ) : (
              <div className="glossary-buttons">
                <p>Configure your printing settings before proceeding.</p>
                <Button label="Print Now" onClick={handlePrint} className="glossary-modal-button" />
              </div>
            )}
            
            <div className="glossary-buttons">
              
              <Button label="Close" type="danger" onClick={() => setModalType(null)} className="glossary-modal-button" />
            </div>
          </div>
        </div>
      )}
    </section>
    </div>
  );
};

export default GlossarySection;
